import { useQuery } from '@tanstack/react-query';

import { useAnonymousPicksheet } from '../domains/game/domains/common/hooks/useAnonymousPicksheet';
import type { TeamPicks } from '../domains/services/interfaces/team-picks.interface';
import { getBulkContestTeamPicks } from '../domains/services/contest.service.api';
import type { CreatePicksPayload } from '../domains/services/interfaces/create-picks.interface';

import { useContest } from './useContest';

export const useContestTeamPicks = ({
  entryIds = [],
  includeEntries = true,
  slateId,
}: {
  entryIds: string[];
  includeEntries?: boolean;
  slateId?: string;
}) => {
  const contest = useContest();

  const { getValue, isAnonymousPicksheetEnabled } = useAnonymousPicksheet<
    CreatePicksPayload['teams']
  >(contest?.data);

  const data = useQuery({
    queryKey: ['teamPicks', [...entryIds.map((id) => id)], slateId],
    queryFn: () => {
      if (isAnonymousPicksheetEnabled) {
        const storage = getValue() ?? [];

        const generateTeamPicks = (): TeamPicks => ({
          undefined: {
            picks: {
              [slateId]: storage?.map((pick) => ({
                teamId: pick.id,
                gameId: pick.gameId,
              })),
            },
          },
        });

        return generateTeamPicks();
      }
      return getBulkContestTeamPicks({ entryIds, includeEntries, slateId });
    },
    enabled: entryIds.length > 0 || isAnonymousPicksheetEnabled,
  });

  return data;
};
